import { FC } from 'react';
import { BrokerSpecificComponentsProps } from 'v3/pages/LandingPage/Default/BannerSection/UserAuth/LoginModal/types.type';
import UserInput from 'v3/common/components/UserInput';
import PortalToTarget from 'v3/common/components/PortalToTarget';
import Button from 'v3/common/components/Button';
import _ from 'lodash';

const Paytm: FC<BrokerSpecificComponentsProps> = ({ userConfigs, brokerSpecificHandles, switchPage }) => {
  const { reDirectPage, validateClientIdAndRedirect, updatePartialConfigs, isMobile } = brokerSpecificHandles;
  const {
    mobileNumber,
    isLoading,
    isClientValidated,
    shouldShowApiKey,
    shouldShowSecretKey,
    apiKey,
    secretKey,
    selectedBrokerConfig,
    isValidForm,
  } = userConfigs;
  const broker = selectedBrokerConfig?.id;

  return (
    <form
      id={`${broker}-form`}
      onSubmit={(e) => {
        e.preventDefault();
        return isClientValidated
          ? reDirectPage({}, false)
          : validateClientIdAndRedirect({ broker_user_id: mobileNumber ?? '' });
      }}
    >
      <UserInput
        labelValue="Registered mobile number"
        id={`${broker}-mobile-number`}
        type="number"
        autoFocus={!isMobile}
        value={mobileNumber ?? ''}
        isDisabled={isClientValidated}
        placeholder="Enter Registered mobile number"
        onHandleChange={(value) =>
          updatePartialConfigs({ mobileNumber: value === '' ? null : _.toNumber(value) })
        }
      />

      {!isClientValidated && !!mobileNumber && (
        <button
          type="button"
          onClick={() =>
            updatePartialConfigs({
              shouldShowApiKey: true,
              shouldShowSecretKey: true,
              isClientValidated: true,
            })
          }
        >
          <i className="fa-regular fa-gear fa-spin" />
          Change API details?
        </button>
      )}

      {shouldShowApiKey && (
        <UserInput
          labelValue="API Key"
          id={`${broker}-api-key`}
          value={apiKey}
          placeholder="Enter API Key"
          onHandleChange={(value) => updatePartialConfigs({ apiKey: value })}
        />
      )}

      {shouldShowSecretKey && (
        <UserInput
          labelValue="API Secret"
          id={`${broker}-secret-key`}
          value={secretKey}
          placeholder="Enter API Secret"
          onHandleChange={(value) => updatePartialConfigs({ secretKey: value })}
        />
      )}

      {!isValidForm && (
        <div className="alert alert-danger">
          <p>Please fill in all required fields.</p>
        </div>
      )}

      {isClientValidated && (shouldShowApiKey || shouldShowSecretKey) && (
        <button type="button" onClick={() => switchPage()}>
          <i className="fa-regular fa-gear fa-spin" />
          How to generate API details?
        </button>
      )}

      <PortalToTarget targetClassName="login-modal__footer" allowForWeb>
        <Button form={`${broker}-form`} type="submit" isLoading={isLoading}>
          {isClientValidated ? 'Login' : 'Validate'}
        </Button>
      </PortalToTarget>
    </form>
  );
};

export default Paytm;
